import { createContext, useContext } from 'react';
export const OpenListContext = createContext({
    closeDroplist: () => { },
    closeDroplistOnItemClick: false,
});
export const useOpenListContext = () => useContext(OpenListContext);
